import { giphyLightestGrey, giphyWhite } from '@giphy/colors'
import { useHistory } from 'react-router'
import Login from 'shared/components/navbar-dropdown'
import styled from 'styled-components'
import { BackArrowIcon } from '../../icons'

const StyledHeader = styled.div`
    display: flex;
    align-items: center;
    margin-top: 30px;
`

const BackButton = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    margin-right: auto;
    flex: 1;
    color: ${giphyWhite};
    font-size: 17px;
    font-weight: bold;

    span {
        padding: 0 8px;
    }
`

const LoginContainer = styled.div`
    flex: 1;
`

const MainText = styled.div`
    text-align: center;
    flex: 2;
    min-width: 0;
`

const Title = styled.div`
    font-family: NexaBlack;
    font-size: 28px;
    background: linear-gradient(135deg, rgba(154, 51, 254, 1) 0%, rgba(253, 101, 99, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
`

const Subtitle = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: ${giphyLightestGrey};
`

type Props = {
    title?: string
    subtitle?: string
}

const Header = ({ title, subtitle }: Props) => {
    const history = useHistory()
    const onBackClick = () => {
        history.push('/supercut')
    }

    return (
        <StyledHeader>
            <BackButton onClick={onBackClick}>
                <BackArrowIcon />
                <span>Back</span>
            </BackButton>
            <MainText>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </MainText>
            <LoginContainer>
                <Login isSupercut={true} />
            </LoginContainer>
        </StyledHeader>
    )
}

export default Header
